import React, { useMemo } from "react";
import { ComponentProps } from "../../types/types";
import BackgroundImageCard from "../@shared/BackgroundImageCard";
import "./ContactModule.scss";
import ContactContent from "./ContactContent/ContactContent";
import CustomSelect from "../CustomSelect";
import NewsletterContent from "./NewsletterContent/NewsletterContent";
import withErrorCatch from "../../helper/withErrorCatch";
import { useTranslation } from "react-i18next";

const ContactModule = (props: ContactModuleProps) => {
  try {
    const { fields } = props;

    if (!fields) {
      return null;
    }
    const { t } = useTranslation();
    const contactCard = useMemo(() => {
      return fields.cards[0].fields;
    }, [props]);

    const optionsList = useMemo(() => {
      if (contactCard.countryTelefonNumberMapping) {
        if (typeof contactCard.countryTelefonNumberMapping.value === "string") {
          return Array.from(
            new URLSearchParams(contactCard.countryTelefonNumberMapping.value)
          ).map(([key, value]) => ({
            Name: key,
            Value: value,
          }));
        } else {
          return contactCard.countryTelefonNumberMapping.value;
        }
      }
    }, [props]);

    const contactData = {
      title: fields.title,
      subtitle: fields.fullDescription,
      ctaText: contactCard.linkTitle,
      image: contactCard.image,
      cardContent: (
        <ContactContent
          icon={{ value: "icon-headphone" }}
          title={contactCard.title}
          content={contactCard.fullDescription}
          formPlaceholder={contactCard.countryTelefonNumberMappingTitle}
          select={
            <CustomSelect
              placeholder={t("SelectYourCountry")}
              optionsList={optionsList}
            />
          }
          linkTitle={contactCard.linkTitle}
          link={contactCard.link}
        />
      ),
    };

    const newsletterCard = fields.cards[1].fields;
    const newsletterData = {
      image: newsletterCard.image,
      cardContent: (
        <NewsletterContent
          icon={{ value: "icon-newsletter" }}
          title={newsletterCard.title}
          content={newsletterCard.fullDescription}
          formPlaceholder={newsletterCard.formTitle}
          linkTitle={{ value: "SUBSCRIBE" }}
        />
      ),
    };
    return (
      <div>
        <div
          className={`ContactModule ${
            props?.fields?.backgroundColor?.value === "Lightgray"
              ? "ContactModule--bg-grey"
              : ""
          }`}
        >
          <BackgroundImageCard
            cssClass={"CardBox__contact"}
            titleColor={"black"}
            fields={contactData}
            skipAnimation={fields?.skipAnimation?.value}
          ></BackgroundImageCard>
          <BackgroundImageCard
            cssClass={"CardBox__contact"}
            fields={newsletterData}
            skipAnimation={fields?.skipAnimation?.value}
          />
        </div>
      </div>
    );
  } catch (error) {
    return <>{(error as Error)?.stack}</>;
  }
};

export default withErrorCatch(ContactModule);

export interface ContactModuleProps extends ComponentProps {}
